import { GraphQLEnumType } from 'graphql'

export type ReactionOperation = 'NOOP' | 'DISABLE'

export const reactionOperationType = new GraphQLEnumType({
  name: 'ReactionOperation',
  description: 'Actions that the agent could take.',
  values: {
    NOOP: {
      description: 'No operation/no action required from agent.'
    },
    DISABLE: {
      description: 'Disable agent activity.'
    }
  }
})
